import * as actions from "./actions";

const initialState = {
	loading: false,
	errors: {}
};

const reducer = function(state = initialState, { type, payload }) {
	switch (type) {
		case actions.CREATE_PERMISSION: {
			return {
				...state,
				loading: true
			};
		}
		case actions.CREATE_PERMISSION_SUCCESS: {
			return {
				...state,
				loading: false,
				errors: {}
			};
		}
		case actions.CREATE_PERMISSION_ERROR: {
			return {
				...state,
				errors: payload,
				loading: false
			};
		}

		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
